export class TMnAplicacionDominioRequest {
    idenT_APLICACION_DOMINIO: number | null = null;
    inD_ESTADO: boolean | null = null;
}
